import { observable, computed, action, autorun } from "mobx";

import toTree from "./toTree";

class AllStore {
  @observable steps;
  @observable selectedStepIndex = 0;
  @observable selectedFilePath = null;

  constructor(steps) {
    this.steps = steps;

    // NOTE: The console.log statement is actually signifigant here, because it tells MobX that
    // this function needs to run whenever the step index changes.
    autorun(() => {
      console.log(`Current selected step: ${this.selectedStepIndex}`); // eslint-disable-line no-console
      window.scrollTo(0, 0);
    });
  }

  @computed
  get selectedStep() {
    return this.steps[this.selectedStepIndex];
  }

  @computed
  get selectedFile() {
    return this.files.find(file => {
      return file.path === this.selectedFilePath;
    });
  }

  @computed
  get onFirstStep() {
    return this.selectedStepIndex === 0;
  }

  @computed
  get onLastStep() {
    return this.selectedStepIndex === this.steps.length - 1;
  }

  @computed
  get files() {
    return this.selectedStep.files;
  }

  @computed
  get fileTree() {
    return toTree(this.files);
  }

  @action
  setSelectedStepIndex(selectedStepIndex) {
    this.selectedStepIndex = selectedStepIndex;
  }

  @action
  setSelectedFilePath(selectedFilePath) {
    this.selectedFilePath = selectedFilePath;
  }
}
export default AllStore;



// WEBPACK FOOTER //
// ./src/byos/logic/AllStore.js